import { GOOGLE_ADS_ID, GOOGLE_ADS_LINKER, ensureGoogleAdsGtag, isGoogleAdsMeasurementHost } from '@shared/utils/google-ads';
import { useEffect } from 'react';

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}

/** Google Ads tag on the prospect portal, where a finished profile is the campaign conversion. */
export function ProductionGoogleAds(): null {
  useEffect(() => {
    if (!isGoogleAdsMeasurementHost(window.location.hostname)) return;

    let cancelled = false;
    const browser = window as Window & {
      dataLayer?: unknown[];
      gtag?: (...args: unknown[]) => void;
    };

    void (async () => {
      ensureGoogleAdsGtag(browser);

      await loadScript(
        `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GOOGLE_ADS_ID)}`,
      );
      if (cancelled || !browser.gtag) return;

      browser.gtag('js', new Date());
      browser.gtag('set', 'linker', { ...GOOGLE_ADS_LINKER });
      browser.gtag('config', GOOGLE_ADS_ID, {
        linker: { ...GOOGLE_ADS_LINKER },
      });
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
